module.exports = __webpack_public_path__ + "images/category_lp/jewel/assessment_achievements/5_49fac623826e7613efafcc1a89172960.jpg";